import { FC } from "react";
import AppContainerWrapper from "../components/AppContainerWrapper";

import packageJson from "../../package.json";

const Footer: FC = () => {
  const CREATED_BY = process.env.REACT_APP_CREATED_BY || "";

  return (
    <AppContainerWrapper
      className="footer py-4 d-flex flex-lg-column"
      id="kt_footer">
      <div
        className={
          "d-flex flex-column flex-md-row align-items-center justify-content-between"
        }>
        {/* begin::Copyright */}
        <div className="text-dark order-2 order-md-1">
          <span className="text-muted fw-bold me-2">
            {new Date().getFullYear()} &copy;
          </span>
          <a href="#" className="text-gray-800 text-hover-primary">
            {CREATED_BY}
          </a>
        </div>
        {/* end::Copyright */}
        {/* begin: version */}
        <div className="text-dark order-1">
          <span className="text-muted fw-bold me-2">Version:</span>
          <span className="text-gray-800 text-hover-primary">
            {packageJson.version}
          </span>
        </div>
        {/* end: version */}
      </div>
    </AppContainerWrapper>
  );
};

export { Footer };
